import { render, staticRenderFns } from "./EmailAddressBookModal.vue?vue&type=template&id=508f182e"
import script from "./EmailAddressBookModal.vue?vue&type=script&lang=js"
export * from "./EmailAddressBookModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports